import React from 'react';
import EmbedPost from '../../../../components/Messaging/Comments/EmbedPost';
import PostPreviewLayoutMC from './PostPreviewLayoutMC';

/**
 * Preview for Facebook and Instagram comment posts. The post data comes from
 * `conversation.facebookPost`: Facebook renders an embedded post, while
 * Instagram falls back to EmbedPost.
 *
 * @component FacebookPostPreviewMC
 * @param {Object} props - Component properties
 * @param {Object} props.conversation - The conversation object containing platform and post info.
 * @returns {JSX.Element|null} The rendered preview, or null when there is no post.
 */
const FacebookPostPreviewMC = ({ conversation }) => {
  const post = conversation?.facebookPost;

  if (!post) return null;

  let embedUrl = post.link;
  let isVideo = false;

  // Normalize Reel URLs for the iframe
  if (embedUrl && embedUrl.includes('/reel/')) {
    const match = embedUrl.match(/\/reel\/(\d+)/);
    if (match && match[1]) {
      embedUrl = `https://www.facebook.com/video.php?v=${match[1]}`;
      isVideo = true;
    }
  } else if (embedUrl && embedUrl.includes('/videos/')) {
    isVideo = true;
  }

  return (
    <PostPreviewLayoutMC originalPostUrl={post.link}>
      {isVideo ? (
        <iframe
          src={`https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(embedUrl)}&show_text=false`}
          width="100%"
          height="300"
          style={{ border: 'none', overflow: 'hidden' }}
          scrolling="no"
          frameBorder="0"
          allowFullScreen={true}
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        ></iframe>
      ) : (
        <EmbedPost post={post} width="100%" platform={conversation.platform} />
      )}
    </PostPreviewLayoutMC>
  );
};

export default FacebookPostPreviewMC;
